import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "space_new",
  "use": "space_new-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"space_new\"><path d=\"M2 13.77V11H0v2.77C0 17.2 2.79 20 6.23 20H9v-2H6.23C3.9 18 2 16.1 2 13.77m0-7.54C2 3.9 3.9 2 6.23 2H9V0H6.23A6.23 6.23 0 0 0 0 6.23V9h2zM12 10c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m6 3.77C18 16.1 16.1 18 13.77 18H11v2h2.77C17.2 20 20 17.21 20 13.77V11h-2zM13.77 0H11v2h2.77C16.1 2 18 3.9 18 6.23V9h2V6.23A6.23 6.23 0 0 0 13.77 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol